// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ctgA","bigColWidth":"Table_bigColWidth__2F612","biggerColWidth":"Table_biggerColWidth__2i7Fs","row":"Table_row__1rPfe","col":"Table_col__UXTwu"};